import request from 'superagent';
import { notify } from '../../components/common/Notification';
import url from '../../utils/url';
import * as actionTypes from '../actionTypes/searchAlertsActionTypes';

export const getAutomatedReports = () => (dispatch) => {
  dispatch({ type: actionTypes.AUTOMATED_REPORTS.REQUEST });

  request
    .get(url('/localsearch/get-alerts'))
    .set('Content-Type', 'application/json')
    .then(
      ({ body = {} }) =>
        dispatch({
          type: actionTypes.AUTOMATED_REPORTS.SUCCESS,
          data: body,
        }),
      (error) => {
        dispatch({
          type: actionTypes.AUTOMATED_REPORTS.ERROR,
          error,
        });
        notify.error('Failed to fetch Automated Reports');
      },
    );
};

export const removeAutomatedReport = ({ id }) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_AUTOMATED_REPORT.REQUEST,
    data: { id },
  });

  request
    .post(url('/localsearch/remove-alert'))
    .send({ id })
    .set('Content-Type', 'application/json')
    .then(
      ({ body = {} }) => {
        dispatch({
          type: actionTypes.REMOVE_AUTOMATED_REPORT.SUCCESS,
          data: body,
        });
        dispatch(getAutomatedReports());
        notify.success('Automated Report was removed successfully');
      },
      (error) => {
        dispatch({
          type: actionTypes.REMOVE_AUTOMATED_REPORT.ERROR,
          error,
        });
        notify.error('Failed to remove Automated Report');
      },
    );
};

export const getTemplateAlerts = () => (dispatch) => {
  dispatch({ type: actionTypes.TEMPLATE_ALERTS.REQUEST });

  request
    .get(url('/search-alerts/json/list-templates'))
    .set('Content-Type', 'application/json')
    .then(
      ({ body = {} }) =>
        dispatch({
          type: actionTypes.TEMPLATE_ALERTS.SUCCESS,
          data: body,
        }),
      (error) => {
        dispatch({
          type: actionTypes.TEMPLATE_ALERTS.ERROR,
          error,
        });
        notify.error('Failed to fetch Template Alerts');
      },
    );
};

export const updateTemplateAlert = payload => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_TEMPLATE_ALERT.REQUEST,
    payload,
  });

  const { name, value, alert } = payload;

  const onSuccess = () => {
    dispatch({
      type: actionTypes.UPDATE_TEMPLATE_ALERT.SUCCESS,
      payload,
    });
    notify.success(`Template Alert ${alert.name} updated successfully`);
  };

  const onError = (error) => {
    dispatch({
      type: actionTypes.UPDATE_TEMPLATE_ALERT.ERROR,
      error,
      payload,
    });
    notify.error(`Failed to update Template Alert ${alert.name}`);
  };

  request
    .post(url(`/search-alerts/json/edit/${alert.id}`))
    .set('Content-Type', 'application/json')
    .set('X-Csrf-Token', alert.edit_token)
    .send({
      [name]: value,
    })
    .then(({ body }) => (
      body && body.success ? onSuccess() : onError(body && body.error)
    ))
    .catch(error => onError(error));
};


export const resendTemplateAlert = payload => (dispatch) => {
  dispatch({
    type: actionTypes.RESEND_TEMPLATE_ALERT.REQUEST,
    payload,
  });

  const { alert } = payload;

  const onSuccess = () => {
    dispatch({
      type: actionTypes.RESEND_TEMPLATE_ALERT.SUCCESS,
      payload,
    });

    notify.success(`Template Alert ${alert.name} was queued for resend`);
  };

  const onError = (error) => {
    dispatch({
      type: actionTypes.RESEND_TEMPLATE_ALERT.ERROR,
      error,
      payload,
    });

    notify.error(`Failed to resend Template Alert ${alert.name}`);
  };

  request
    .post(url(`/search-alerts/json/resend/${alert.id}`))
    .set('Content-Type', 'application/json')
    .set('X-Csrf-Token', alert.resend_token)
    .then(({ body }) => (
      body && body.success ? onSuccess() : onError(body && body.error)
    ))
    .catch(error => onError(error));
};

export const getCustomAlerts = () => (dispatch) => {
  dispatch({ type: actionTypes.CUSTOM_ALERTS.REQUEST });

  request
    .get(url('/search-alerts/json/list'))
    .set('Content-Type', 'application/json')
    .then(
      ({ body = {} }) =>
        dispatch({
          type: actionTypes.CUSTOM_ALERTS.SUCCESS,
          data: body,
        }),
      (error) => {
        dispatch({
          type: actionTypes.CUSTOM_ALERTS.ERROR,
          error,
        });
        notify.error('Failed to fetch Custom Alerts');
      },
    );
};

export const updateCustomAlert = payload => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_CUSTOM_ALERT.REQUEST,
    payload,
  });

  const { alert } = payload;

  const onSuccess = () => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_ALERT.SUCCESS,
      payload,
    });

    notify.success(`Custom Alert ${alert.name} updated successfully`);
  };

  const onError = (error) => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_ALERT.ERROR,
      error,
      payload,
    });

    notify.error(`Failed to update Custom Alert ${alert.name}`);
  };

  request
    .post(url(`/search-alerts/json/edit/${alert.id}`))
    .set('Content-Type', 'application/json')
    .set('X-Csrf-Token', alert.edit_token)
    .send({
      ...alert,
    })
    .then(({ body }) => (
      body && body.success ? onSuccess() : onError(body && body.error)
    ))
    .catch(error => onError(error));
};

export const removeCustomAlert = payload => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_CUSTOM_ALERT.REQUEST,
    payload,
  });

  const { alert } = payload;

  const onSuccess = () => {
    dispatch({
      type: actionTypes.REMOVE_CUSTOM_ALERT.SUCCESS,
      payload,
    });
    notify.success(`Custom Alert ${alert.name} was removed successfully`);
  };

  const onError = (error) => {
    dispatch({
      type: actionTypes.REMOVE_CUSTOM_ALERT.ERROR,
      error,
      payload,
    });
    notify.error(`Failed to remove Custom Alert ${alert.name}`);
  };

  request
    .post(url(`/search-alerts/json/delete/${alert.id}`))
    .set('Content-Type', 'application/json')
    .set('X-Csrf-Token', alert.edit_token)
    .then(({ body = {} }) => (
      body && body.success ? onSuccess() : onError(body && body.error)
    ))
    .catch(error => onError(error));
};

export const getDeliveryLog = (alertId) => (dispatch) => {
  dispatch({ type: actionTypes.DELIVERY_LOG.REQUEST });

  request
    .get(url(`/search-alerts/json/delivery-log/${alertId}`))
    .set('Content-Type', 'application/json')
    .then(
      ({ body = [] }) =>
        dispatch({
          type: actionTypes.DELIVERY_LOG.SUCCESS,
          data: body,
        }),
      (error) => {
        dispatch({
          type: actionTypes.DELIVERY_LOG.ERROR,
          error,
        });
        notify.error('Failed to fetch delivery log');
      },
    );
};

export const resendCustomAlert = payload => (dispatch) => {
  dispatch({
    type: actionTypes.RESEND_CUSTOM_ALERT.REQUEST,
    payload,
  });

  const { alert } = payload;

  const onSuccess = () => {
    dispatch({
      type: actionTypes.RESEND_CUSTOM_ALERT.SUCCESS,
      payload,
    });

    notify.success(`Custom Alert ${alert.name} was queued for resend`);
  };

  const onError = (error) => {
    dispatch({
      type: actionTypes.RESEND_CUSTOM_ALERT.ERROR,
      error,
      payload,
    });

    notify.error(`Failed to resend Custom Alert ${alert.name}`);
  };

  request
    .post(url(`/search-alerts/json/resend/${alert.id}`))
    .set('Content-Type', 'application/json')
    .set('X-Csrf-Token', alert.resend_token)
    .then(({ body }) => (
      body && body.success ? onSuccess() : onError(body && body.error)
    ))
    .catch(error => onError(error));
};



// WEBPACK FOOTER //
// ./src/redux/actions/searchAlertsAction.js